import { types } from "../types/types";

export const uiOpenModalUser = () => ({
    type: types.uiOpenModalUser
});

export const uiCloseModalUser = () => ({
    type: types.uiCloseModalUser
});